"use client";

import type { Locale, Unit } from "@/types/units";
import { X } from "lucide-react";
import { useLocale } from "next-intl";

/** A unit column header — image, code, project, remove button. */
export default function CompareUnitCard({
  unit,
  onRemove,
}: {
  unit: Unit;
  onRemove: () => void;
}) {
  const locale = useLocale() as Locale;

  return (
    <div className="group relative border-e border-black/10 p-6 dark:border-white/10">
      <button
        onClick={onRemove}
        aria-label={locale === "ar" ? "إزالة" : "Remove"}
        className="absolute top-4 start-4 text-ash/40 transition-colors hover:text-accent dark:text-white/40"
      >
        <X className="h-5 w-5" />
      </button>
      <div className="mb-4 aspect-square overflow-hidden border border-black/10 p-1 dark:border-white/10">
        <img
          src={unit.images[0]}
          alt={unit.code}
          className="h-full w-full object-cover opacity-80 grayscale transition-all duration-500 group-hover:opacity-100 group-hover:grayscale-0"
        />
      </div>
      <div className="font-bebas text-2xl text-ash dark:text-white">{unit.code}</div>
      <div className="text-[11px] uppercase tracking-widest text-ash/50 dark:text-white/50">
        {unit.project[locale]}
      </div>
    </div>
  );
}
